import React from 'react';

function StarRating({ rating }) {
  const renderStars = () => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const stars = [];
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="text-orange-400">★</span>);
    }
    if (hasHalfStar) {
      stars.push(<span key="half" className="text-orange-400">☆</span>);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="text-orange-400 opacity-30">★</span>);
    }
    return stars;
  };

  return (
    <span className="text-sm tracking-wider">
      {renderStars()}
    </span>
  );
}

export default StarRating;
